import { render } from "./warehouse-create-import.vue?vue&type=template&id=34838d89"
import script from "./warehouse-create-import.vue?vue&type=script&lang=js"
export * from "./warehouse-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__